import { render, staticRenderFns } from "./index.vue?vue&type=template&id=22a9ba58&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=22a9ba58&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a9ba58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22a9ba58')) {
      api.createRecord('22a9ba58', component.options)
    } else {
      api.reload('22a9ba58', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=22a9ba58&scoped=true", function () {
      api.rerender('22a9ba58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/solution/HealthcareSolutions/index.vue"
export default component.exports